/** What happened to a comment and who did it (ALP-84): one shared component everywhere a comment is shown. */
export const commentStatus = {
  label: "Comment status",
  who: {
    you: "you",
    user: "{{name}}",
    teammate: "a teammate",
    rule: "rule “{{name}}”",
    ruleUnnamed: "a rule",
    agent: "AI agent “{{name}}”",
    agentUnnamed: "an AI agent",
    instagram: "Instagram",
    author: "the author",
    system: "Malfak",
  },
  badge: {
    deleted: "Deleted",
    hidden: "Hidden",
    replied: "Replied",
    privateReply: "Replied in DM",
    rule: "Rule",
  },
  line: {
    deleted: "Deleted by {{who}}",
    deletedOnInstagram: "Deleted on Instagram",
    deletedByAuthor: "Deleted by the author",
    hidden: "Hidden by {{who}}",
    hiddenBlocked: "Hidden because the author is blocked",
    unhidden: "Shown again by {{who}}",
    replied: "Replied by {{who}}",
    private_reply: "Replied in a DM by {{who}}",
    tagged: "Tagged “{{detail}}” by {{who}}",
    taggedPlain: "Tagged by {{who}}",
    untagged: "Tag removed by {{who}}",
    archived: "Archived by {{who}}",
    unarchived: "Brought back by {{who}}",
    pinned: "Pinned by {{who}}",
    unpinned: "Unpinned by {{who}}",
    rule: "{{who}} acted on it",
  },
  ruleDid: {
    hide: "hid it",
    delete: "deleted it",
    reply: "replied",
    reply_private: "replied in a DM",
    flag: "tagged it",
    notify: "notified the team",
    other: "acted on it",
  },
  history: "What happened",
  noHistory: "Nothing has happened to this comment yet.",
  openRule: "Open the rule",
  openRun: "Open in the automation log",
  blocked: "Author blocked",
};
